module.exports = __webpack_public_path__ + "static/img/playing.f5a751d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/playing.gif
// module id = Z5dl
// module chunks = 1